module.exports = __webpack_public_path__ + "img/App_Realpros.823d9df2.png";